<template>
  <div class="pa-park-note-comment-view">
    <ul>
      <li v-for="comment in commentList" :key="comment.id">
        <PAParkNoteComment :commentId="comment.id" />
      </li>
    </ul>
  </div>
</template>

<script>
import PAParkNoteComment from '@/components/Pages/Parks/Note/PAParkNoteComment/PAParkNoteComment.vue'

export default {
  props : {
    commentList : {
      default: () => {
        return [];
      }
    }
  },

  components : {
    PAParkNoteComment
  }
}
</script>

<style lang="scss">
.pa-park-note-comment-view{
  ul{
    li{
      padding-bottom:.5rem;
      margin-bottom:.5rem;
      border-bottom:1px solid #c5a384;

      // &:first-child{
      //   border-top:1px solid #c5a384;
      //   padding-top:.5rem;
      // }

      &:last-child{
        border-bottom:0;
      }
    }
  }
}
</style>